const comments = [
  {
    text: '妖精动漫的阅读体验太流畅了，下拉式看漫画真的很爽！资源也很全，日漫韩漫都有，已经在这里追了半年多了。',
    name: '漫友小明',
    role: '资深读者',
  },
  {
    text: '韩漫资源很全，更新也快，画质清晰，已经推荐给身边所有喜欢看漫画的朋友了。不用注册这点真的良心！',
    name: '二次元少女',
    role: '韩漫爱好者',
  },
  {
    text: '之前找了很多漫画网站，要么要付费要么广告太多，妖精动漫完全没有这些问题。收藏功能很好用，追更提醒很及时。',
    name: '追漫达人',
    role: '忠实用户',
  },
  {
    text: '国漫专区资源越来越丰富了，画质和翻译质量都很好。希望妖精动漫越做越好，坚持免费路线！',
    name: '夜猫子读漫',
    role: '国漫粉丝',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            读者热评
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[480px] mx-auto">
            听听妖精动漫平台的读者们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((c, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star} className="w-4 h-4 flex items-center justify-center text-accent-400 text-xs">
                    <i className="ri-star-fill"></i>
                  </span>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1 mb-4">
                &ldquo;{c.text}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-100">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-primary-600">
                    {c.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{c.name}</p>
                  <p className="text-xs text-foreground-500">{c.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}